import React from "react";
import { useOnboardingStore } from "@/stores";

export interface NavigationProps {
  type: "client" | "jobber";
  currentStep: number;
  onStepClick?: (step: number) => void;
  isSetupMode?: boolean; // New prop to control navigation in setup mode
}

const stepsMap: Record<NavigationProps["type"], string[]> = {
  client: ["My User Information", "Company information"],
  jobber: [
    "General Information",
    "Specialty & Skills",
    "Experience & Education",
  ],
};

export const NavigationProfileSetup: React.FC<NavigationProps> = ({
  type,
  currentStep,
  onStepClick,
  isSetupMode = false, // Default to false for backward compatibility
}) => {
  const steps = stepsMap[type];
  const isFirstStepComplete = useOnboardingStore(
    (state) => state.isFirstStepComplete
  );

  const handleStepClick = (stepIndex: number) => {
    if (onStepClick) {
      onStepClick(stepIndex);
    }
  };

  return (
    <nav className="w-full mb-5">
      {/* Desktop Tabs */}
      <div className="hidden sm:block">
        <div className="flex gap-6 mb-8 border-b border-[#ECECEC]">
          {steps.map((label, idx) => {
            const selected = idx === currentStep;
            const isDisabled =
              isSetupMode &&
              currentStep === 0 &&
              idx > 0 &&
              !isFirstStepComplete();

            return (
              <button
                key={idx}
                onClick={() => handleStepClick(idx)}
                disabled={isDisabled}
                className={`pb-4 px-1 font-medium text-sm transition relative ${
                  selected
                    ? "text-[#222]"
                    : isDisabled
                    ? "text-gray-300 cursor-not-allowed"
                    : "text-[#AAA]"
                }`}
              >
                {label}
                {selected && (
                  <div
                    className="absolute bottom-[-1px] left-0 right-0 h-0.5"
                    style={{
                      background: 'linear-gradient(to right, #FF55E8, #B71BFF, #9747FF, #5B02FF)'
                    }}
                  />
                )}
              </button>
            );
          })}
        </div>
      </div>

      {/* Mobile Progress Bar */}
      <div className="sm:hidden px-4 pt-4 pb-2">
        <p className="text-center text-black text-xl font-semibold">
          {steps[currentStep]}
        </p>
      </div>
    </nav>
  );
};

export default NavigationProfileSetup;
